import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetSiteSaga() {
    yield put(appActions.SITES_RESET_SUCCESS());
}

function* watchSiteUpdateRequest() {
    yield takeLatest(
        appActions.SITES_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/site/update',
                appActions.SITES_UPDATE_SUCCESS,
                appActions.SITES_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchSiteCreateRequest() {
    yield takeLatest(
        appActions.SITES_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/communication/v1/site/save',
                appActions.SITES_CREATE_SUCCESS,
                appActions.SITES_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchSiteDeleteRequest() {
    yield takeLatest(
        appActions.SITES_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                `/communication/v1/site`,
                appActions.SITES_DELETE_SUCCESS,
                appActions.SITES_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchSiteGetAllRequest() {
    yield takeLatest(
        appActions.SITES_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/site',
                appActions.SITES_GET_ALL_SUCCESS,
                appActions.SITES_GET_ALL_FAILURE,
            );
        },
    );
}


function* watchSyncSiteRequest() {
    yield takeLatest(
        appActions.SITES_SYNCSITE_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/communication/v1/site/sync-site',
                appActions.SITES_SYNCSITE_SUCCESS,
                appActions.SITES_SYNCSITE_FAILURE,
            );
        },
    );
}

export default function* sitesWatcher() {
    yield* watchSiteUpdateRequest();
    yield* watchSiteCreateRequest();
    yield* watchSiteGetAllRequest();
    yield* watchSiteDeleteRequest();
    yield* watchSyncSiteRequest();
    yield takeLatest(
        appActions.SITES_RESET_REQUEST.type,
        resetSiteSaga,
    );
    // Add other watchers here
}
